import * as React from 'react';
import classNames from 'classnames';
import { isArray as _isArray} from 'lodash';
import { randomHash } from 'src/api';
import { Button, Collapse } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import {
  ValidationItem,
} from 'franke-trough-dependencies';

import IconErrorWithToolTip from 'src/app/Partials/Icons/IconErrorWithToolTip';

import './Accordion.scss';


export interface AccordionProps {
  children: JSX.Element | JSX.Element[];
}

export interface AccordionState {
  toggleState: boolean[];
}

export class Accordion extends React.Component<AccordionProps, AccordionState> {

  constructor(props: AccordionProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      toggleState: this.defaultToggleState(),
    };
  }

  public render() {
    const children: JSX.Element[] = _isArray(this.props.children) ? (this.props.children as JSX.Element[]) : [this.props.children] || [];
    const {toggleState} = this.state;
    return (
      <div className="accordion">
        {children.map((child, index) => {
          const key = `accordion_${index}_${randomHash()}`;
          const props = child.props;
          
          const Component = props && props.component;
          const hasError = props && props.error && props.error.some((err: false | ValidationItem) => err !== false ? true : false) || false;
          
          const hasChildren = props && props.children ? true : false;
          return child && (hasChildren || Component) ? (
            <div key={key} className="accordion-item border-bottom">
              <div 
                className={classNames(
                  'accordion-btn', {
                    'show': toggleState[index],
                    'color-danger': hasError
                  }
                )}
              >
                <Button className="btn border-0 p-0 w-100 text-left" onClick={() => this.handleClick(index)}>
                  <span className="btn-name">
                    {child.props.btnName || 'Open'}
                    {hasError && (
                      <IconErrorWithToolTip 
                        error={props && props.error}
                        id={props && props.id}
                        inline={true}
                      />
                    )}
                  </span>
                  <span className="icon-svg"><FontAwesomeIcon icon={faChevronDown} /></span>
                </Button>
              </div>
              <div className="accordion-body">
                <Collapse isOpen={toggleState[index]}>
                  {hasChildren && !Component && child}
                  {!hasChildren && Component && (
                    <Component isOpenAccordion={toggleState[index]} />
                  )}
                </Collapse>
              </div>
            </div>
          ) : null;
        })}
      </div>
    );
  }

  private handleClick(index: number) {
    const {toggleState} = this.state;
    const newToggleState: boolean[] = [];
    toggleState.map((child, idx) => index === idx ? newToggleState.push(!child) : newToggleState.push(false));
    this.setState({
      toggleState: newToggleState
    });
  }
  
  private defaultToggleState(): boolean[] {
    const children: JSX.Element[] = _isArray(this.props.children) ? (this.props.children as JSX.Element[]) : [this.props.children] || [];
    const itemStates: boolean[] = [];
    children.map((child, index) => index === 0 ? itemStates.push(true) : itemStates.push(false));
    return itemStates;
  }
}

export default Accordion;
